import { Maintenance, MaintenanceType } from '@repo/types';
import { $api } from './base';

export const getMaintenance = (type: MaintenanceType): Promise<Maintenance> => {
  return $api
    .get(`/api/admin/maintenance/`, { params: { type } })
    .then((response) => response.data);
};

export const createMaintenance = (
  data: Partial<Maintenance>,
): Promise<Maintenance> => {
  return $api
    .post(`/api/admin/maintenance/`, { ...data })
    .then((response) => response.data);
};

export const updateMaintenance = (
  data: Partial<Maintenance & { id: string }>,
): Promise<Maintenance> => {
  return $api
    .patch(`/api/admin/maintenance/${data.id}/`, {
      ...data,
    })
    .then((response) => response.data);
};
